<template>
  <div class="quotation-step" :class="{ 'flow-step--readonly': viewOnly }">
    <div v-if="false" class="quotation-step__toolbar">
      <el-dropdown @command="handleCommand">
        <el-button type="primary">
          Add Quotation
          <i class="el-icon-arrow-down el-icon--right" />
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="primaryLabor">
            Approx. Labor Cost Quotation
          </el-dropdown-item>
          <el-dropdown-item command="secondaryLabor">
            Detailed Labor Cost Quotation
          </el-dropdown-item>
          <el-dropdown-item command="approxProducts">
            Approx. Products Quotation
          </el-dropdown-item>
          <el-dropdown-item command="detailedProducts">
            Request Detail Product Quotation
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <div class="quotation-step__cards">
      <article class="quotation-mobile-card quotation-mobile-card--vendor">
        <header class="quotation-mobile-card__header">
          <div class="quotation-mobile-card__icon quotation-mobile-card__icon--vendor">
            <i class="fas fa-tools" aria-hidden="true" />
          </div>
          <div class="quotation-mobile-card__titles">
            <h3 class="quotation-mobile-card__title">{{ vendorCardTitle }}</h3>
            <p class="quotation-mobile-card__subtitle">Labor quotation</p>
          </div>
          <button
            type="button"
            class="quotation-mobile-card__link"
            @click="openVendorQuotationModal"
          >
            {{ vendorQuotationStats.total }} quotation<span
              v-if="vendorQuotationStats.total !== 1"
              >s</span
            >
            <span class="quotation-mobile-card__chevron">›</span>
          </button>
        </header>

        <div class="quotation-mobile-card__stats">
          <div class="quotation-stat-row">
            <span>Accepted</span>
            <span>{{ vendorQuotationStats.accepted }}</span>
          </div>
          <div class="quotation-stat-row">
            <span>Pending</span>
            <span>{{ vendorQuotationStats.pending }}</span>
          </div>
          <div class="quotation-stat-row">
            <span>Rejected</span>
            <span>{{ vendorQuotationStats.rejected }}</span>
          </div>
          <div class="quotation-stat-row quotation-stat-row--total">
            <span>Total</span>
            <span>{{ formatQuotationAmount(vendorQuotationAmount) }}</span>
          </div>
        </div>
      </article>

      <article class="quotation-mobile-card quotation-mobile-card--rajput">
        <header class="quotation-mobile-card__header">
          <div class="quotation-mobile-card__icon quotation-mobile-card__icon--rajput">
            <i class="fas fa-box" aria-hidden="true" />
          </div>
          <div class="quotation-mobile-card__titles">
            <h3 class="quotation-mobile-card__title">{{ branchDisplayName }}</h3>
            <p class="quotation-mobile-card__subtitle">Product quotation</p>
          </div>
          <button
            type="button"
            class="quotation-mobile-card__link"
            @click="openRajputQuotationModal"
          >
            {{ rajputQuotationStats.total }} quotation<span
              v-if="rajputQuotationStats.total !== 1"
              >s</span
            >
            <span class="quotation-mobile-card__chevron">›</span>
          </button>
        </header>

        <div class="quotation-mobile-card__stats">
          <div class="quotation-stat-row">
            <span>Accepted</span>
            <span>{{ rajputQuotationStats.accepted }}</span>
          </div>
          <div class="quotation-stat-row">
            <span>Pending</span>
            <span>{{ rajputQuotationStats.pending }}</span>
          </div>
          <div class="quotation-stat-row">
            <span>Rejected</span>
            <span>{{ rajputQuotationStats.rejected }}</span>
          </div>
          <div class="quotation-stat-row quotation-stat-row--total">
            <span>Total</span>
            <span>{{ formatQuotationAmount(rajputQuotationAmount) }}</span>
          </div>
        </div>
      </article>
    </div>

    <el-dialog
      :visible.sync="showVendorQuotationModal"
      :title="vendorCardTitle"
      width="520px"
      custom-class="quotation-detail-dialog"
      @closed="resetVendorQuotationDraft"
    >
      <section v-if="!viewOnly" class="quotation-create-panel quotation-create-panel--modal">
        <h4 class="quotation-panel__title">Create new quotation</h4>
        <p class="quotation-panel__hint">Search labor and add items to the list below.</p>
        <div class="quotation-labor-search">
          <i class="el-icon-search quotation-labor-search__icon" aria-hidden="true" />
          <input
            v-model="laborSearchQuery"
            type="search"
            class="quotation-labor-search__input"
            placeholder="Search or add labor…"
            autocomplete="off"
          />
        </div>
        <ul
          v-if="laborSearchQuery.trim() && filteredLaborCosts.length"
          class="quotation-labor-results"
        >
          <li
            v-for="item in filteredLaborCosts"
            :key="item.laborCostId"
            class="quotation-labor-results__row"
          >
            <button
              type="button"
              class="quotation-labor-results__pick"
              @click="addPendingLabor(item)"
            >
              <span>{{ item.description }}</span>
              <span>{{ formatQuotationAmount(item.cost) }}</span>
            </button>
          </li>
        </ul>
        <ul v-if="pendingLaborItems.length" class="quotation-labor-selected">
          <li
            v-for="(item, index) in pendingLaborItems"
            :key="item.laborCostId || index"
            class="quotation-labor-selected__row"
          >
            <span>{{ item.description }}</span>
            <span class="quotation-labor-selected__amount">{{
              formatQuotationAmount(item.cost)
            }}</span>
            <button
              type="button"
              class="quotation-labor-selected__remove"
              aria-label="Remove"
              @click="removePendingLabor(index)"
            >
              ×
            </button>
          </li>
        </ul>
        <p v-else class="quotation-panel__empty-hint">No labor selected yet.</p>
        <base-button
          type="primary"
          class="quotation-create-btn"
          :disabled="!pendingLaborItems.length || creatingQuotation"
          :loading="creatingQuotation"
          @click="createLaborQuotation()"
        >
          Create quotation
        </base-button>
        <div class="quotation-step__toolbar quotation-step__toolbar--inline">
          <el-button size="small" @click="handleCommand('primaryLabor')">
            Approx. labor cost
          </el-button>
        </div>
      </section>

      <section class="quotation-list-panel quotation-list-panel--modal">
        <header class="quotation-list-panel__header">
          <h4 class="quotation-panel__title">Quotations for this work</h4>
          <span class="quotation-list-panel__badge">{{
            vendorQuotations.length
          }}</span>
        </header>
        <p v-if="!vendorQuotations.length" class="quotation-panel__empty">
          No vendor quotations yet.
        </p>
        <article
          v-for="row in vendorQuotations"
          :key="row.serviceRequestQuotationId"
          class="quotation-list-card"
        >
          <div class="quotation-list-card__top">
            <span class="quotation-list-card__id">{{
              row.quotationNumber || "—"
            }}</span>
            <span class="quotation-list-card__amount">{{
              formatQuotationAmount(row.total)
            }}</span>
            <span
              class="quotation-list-card__status"
              :class="quotationStatusClass(row)"
            >
              {{ quotationStatusLabel(row) }}
            </span>
          </div>
          <p class="quotation-list-card__meta">
            {{ formatQuotationDateTime(row) }}
            ·
            {{ quotationLaborCount(row) }}
            labor
          </p>
          <base-button
            v-if="canAcceptQuotation(row)"
            size="sm"
            type="primary"
            class="quotation-list-card__accept"
            @click="updateQuotation(row)"
          >
            Accept
          </base-button>
        </article>
      </section>
    </el-dialog>

    <el-dialog
      :visible.sync="showRajputQuotationModal"
      :title="branchDisplayName"
      width="520px"
      custom-class="quotation-detail-dialog"
    >
      <div v-if="!viewOnly" class="quotation-step__toolbar quotation-step__toolbar--modal">
        <el-dropdown @command="handleCommand">
          <el-button type="primary" size="small">
            Add product quotation
            <i class="el-icon-arrow-down el-icon--right" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="approxProducts">
              Approx. products
            </el-dropdown-item>
            <el-dropdown-item command="detailedProducts">
              Detailed products
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <section class="quotation-list-panel quotation-list-panel--modal">
        <header class="quotation-list-panel__header">
          <h4 class="quotation-panel__title">Quotations for this work</h4>
          <span class="quotation-list-panel__badge">{{
            rajputQuotations.length
          }}</span>
        </header>
        <p v-if="!rajputQuotations.length" class="quotation-panel__empty">
          No Rajput product quotations yet.
        </p>
        <article
          v-for="row in rajputQuotations"
          :key="row.serviceRequestQuotationId"
          class="quotation-list-card"
        >
          <div class="quotation-list-card__top">
            <span class="quotation-list-card__id">{{
              row.quotationNumber || "—"
            }}</span>
            <span class="quotation-list-card__amount">{{
              formatQuotationAmount(row.total)
            }}</span>
            <span
              class="quotation-list-card__status"
              :class="quotationStatusClass(row)"
            >
              {{ quotationStatusLabel(row) }}
            </span>
          </div>
          <p class="quotation-list-card__meta">
            {{ formatQuotationDateTime(row) }}
            ·
            {{ row.type || "Product quotation" }}
          </p>
          <base-button
            v-if="canAcceptQuotation(row)"
            size="sm"
            type="primary"
            class="quotation-list-card__accept"
            @click="updateQuotation(row)"
          >
            Accept
          </base-button>
        </article>
      </section>
    </el-dialog>

    <template v-if="!viewOnly">
    <!----------------------APPROX LABOR DIALOG-------------->
    <el-dialog :visible.sync="showLaborDialog" title="Approx. Labor Quotation">
      <div class="row">
        <div class="col-md-6">
          <base-input
            v-model="serviceRequestQuotation.total"
            type="number"
            label="Labor Amount"
          />
        </div>
        <div class="col-md-6">
          <base-input label="Description">
            <textarea
              v-model="serviceRequestQuotation.description"
              tabindex="7"
              rows="2"
              class="form-control"
            />
          </base-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showLaborDialog = false">Cancel</el-button>
        <el-button type="primary" @click="saveQuotation('labor-cost')">
          Confirm
        </el-button>
      </span>
    </el-dialog>

    <!----------------------DETAILED LABOR DIALOG-------------->
    <el-dialog
      :visible.sync="showDetailedLaborCost"
      title="Detailed Labor Quotation"
    >
      <div class="row">
        <div class="col-md-6">
          <base-input label="Select Labor">
            <el-select
              v-model="selectedLabor"
              clearable
              filterable
              style="width: 100%"
              value-key="laborCostId"
              @change="addDetailedLabor"
            >
              <el-option
                v-for="(item, index) in laborCosts"
                :key="index"
                :value="item"
                :label="`${item.description} (${item.cost})`"
              />
            </el-select>
          </base-input>
        </div>
      </div>

      <div>
        <el-table :data="detailedLaborCosts">
          <el-table-column label="Description" prop="description" />
          <!-- el="Cost" prop="cost"></el-table-column> -->
          <el-table-column label="Operations">
            <template slot-scope="scope">
              <el-button
                style="margin-bottom: 20px"
                size="mini"
                type="danger"
                @click="handleDetailedLaborCostDelete(scope.$index)"
              >
                <i class="el-icon-delete" />
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showDetailedLaborCost = false">Cancel</el-button>
        <el-button type="primary" @click="saveQuotation('detail-labor-cost')">
          Confirm
        </el-button>
      </span>
    </el-dialog>

    <!---------------------- APPROX. PRODUCTS DIALOG-------------->
    <el-dialog
      :visible.sync="showApproxProducts"
      title="Approx. Products Quotation"
    >
      <div class="row">
        <div class="col-md-6">
          <base-input
            v-model="serviceRequestQuotation.total"
            label="Total Amount"
          />
        </div>
        <div class="col-md-6">
          <base-input label="Description">
            <textarea
              v-model="serviceRequestQuotation.description"
              tabindex="7"
              rows="2"
              class="form-control"
            />
          </base-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showApproxProducts = false">Cancel</el-button>
        <el-button type="primary" @click="saveQuotation('approx-product')">
          Confirm
        </el-button>
      </span>
    </el-dialog>

    <!---------------------- DETAILED PRODUCTS DIALOG-------------->
    <el-dialog
      :visible.sync="showDetailedProducts"
      title="Detailed Products Quotation"
    >
      <base-button
        size="sm"
        type="primary"
        style="float: right"
        @click="handleDetailedProductAdd()"
      >
        Add New
      </base-button>
      <el-table :data="detailedProductData" style="padding-top: 10px">
        <el-table-column label="Product Name">
          <template slot-scope="scope">
            <base-input>
              <el-autocomplete
                v-uppercase
                ref="searchProduct"
                v-model="scope.row.name"
                :fetch-suggestions="suggestProducts"
                :trigger-on-focus="false"
                class="product-search"
                placeholder="Type..."
                tabindex="4"
                style="width: 100%"
                @select="val => handleProductSelect(val, scope.row)"
              >
                <template slot-scope="{ item }">{{ item.name }}</template>
              </el-autocomplete>
            </base-input>
          </template>
        </el-table-column>
        <el-table-column label="Qty." min-width="40">
          <template slot-scope="scope">
            <base-input v-model="scope.row.quantity" />
          </template>
        </el-table-column>
        <el-table-column label="Actions" min-width="40">
          <template slot-scope="scope">
            <el-button
              style="margin-bottom: 20px"
              size="mini"
              type="danger"
              @click="handleDetailedProductDelete(scope.$index)"
            >
              <i class="el-icon-delete" />
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showDetailedProducts = false">Cancel</el-button>
        <el-button type="primary" @click="saveQuotation('detail-product')">
          Request Quotation
        </el-button>
      </span>
    </el-dialog>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import dateFns from "date-fns";
import {
  Dropdown,
  DropdownMenu,
  Button,
  DropdownItem,
  Table,
  TableColumn,
  Dialog,
  Autocomplete,
  Select,
  Option,
  Icon
} from "element-ui";
import branchDetailsMixin from "@/mixins/branchDetailsMixin";
import {
  partitionQuotations,
  quotationStatusCounts,
  vendorDisplayName
} from "@/utils/serviceRequestFlowHelpers";
import serviceRequestFlowViewOnlyMixin from "@/mixins/serviceRequestFlowViewOnlyMixin";

export default {
  mixins: [branchDetailsMixin, serviceRequestFlowViewOnlyMixin],
  directives: {
    uppercase: {
      inserted: function(el, _, vnode) {
        el.addEventListener("input", async function(e) {
          const modified = e.target.value
            .split(" ")
            .map(i => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      }
    }
  },
  filters: {
    dateFormat(value) {
      return dateFns.format(new Date(value), "DD MMM YYYY");
    }
  },
  components: {
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [DropdownItem.name]: DropdownItem,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dialog.name]: Dialog,
    [Autocomplete.name]: Autocomplete,
    [Select.name]: Select,
    [Option.name]: Option,
    [Icon.name]: Icon
  },
  data() {
    return {
      searchKeyword: "",
      laborSearchQuery: "",
      pendingLaborItems: [],
      creatingQuotation: false,
      showVendorQuotationModal: false,
      showRajputQuotationModal: false,
      showLaborDialog: false,
      showApproxProducts: false,
      showDetailedProducts: false,
      showDetailedLaborCost: false,
      primaryLabor: "",
      secondaryLabor: "",
      selectedLabor: {},
      serviceRequestQuotationData: {}
      // selectedProductName: ''
    };
  },

  computed: {
    ...mapState("serviceRequestQuotation", [
      "serviceRequestQuotation",
      "detailedProductData",
      "detailedLaborCosts",
      "serviceRequestQuotations"
    ]),
    ...mapState("laborCost", ["laborCosts"]),
    ...mapState("serviceRequestChalan", ["serviceRequestChalansList"]),
    ...mapState("serviceRequest", ["serviceRequest"]),

    ...mapGetters({
      statusList: "status/getStatusList"
    }),
    vendorName() {
      return vendorDisplayName(this.serviceRequest);
    },
    vendorCardTitle() {
      const vendor = this.serviceRequest && this.serviceRequest.vendor;
      if (!vendor || typeof vendor !== "object") return this.vendorName;
      const firm = (vendor.firmName || vendor.firm_name || "").trim();
      if (firm) return firm;
      return this.vendorName;
    },
    vendorQuotations() {
      return partitionQuotations(
        this.serviceRequestQuotations,
        this.serviceRequest.vendorId
      ).vendor;
    },
    rajputQuotations() {
      return partitionQuotations(
        this.serviceRequestQuotations,
        this.serviceRequest.vendorId
      ).rajput;
    },
    vendorQuotationStats() {
      return quotationStatusCounts(this.vendorQuotations);
    },
    rajputQuotationStats() {
      return quotationStatusCounts(this.rajputQuotations);
    },
    vendorQuotationAmount() {
      return this.sumQuotationTotals(this.vendorQuotations);
    },
    rajputQuotationAmount() {
      return this.sumQuotationTotals(this.rajputQuotations);
    },
    filteredLaborCosts() {
      const q = (this.laborSearchQuery || "").trim().toLowerCase();
      const list = this.laborCosts || [];
      if (!q) {
        return list.slice(0, 15);
      }
      return list
        .filter(item =>
          String(item.description || "")
            .toLowerCase()
            .includes(q)
        )
        .slice(0, 30);
    }
  },

  mounted() {
    this.loadBranchDetails();
    this.fetchServiceRequest(this.$route.params.id);
    this.getServiceRequestQuotations(this.$route.params.id);
    this.getServiceRequestChalans(this.$route.params.id);
    this.getLaborCosts();
    this.getStatuses();
  },
  methods: {
    ...mapActions({
      saveServiceRequestQuotation:
        "serviceRequestQuotation/saveServiceRequestQuotation",
      getServiceRequestQuotations:
        "serviceRequestQuotation/getServiceRequestQuotations",
      getProducts: "product/getProducts",
      getLaborCosts: "laborCost/getLaborCosts",
      fetchServiceRequestQuotationDetails:
        "serviceRequestQuotation/getServiceRequestQuotationDetails",
      getStatuses: "status/getStatusList",
      updateServiceRequestQuotation:
        "serviceRequestQuotation/updateServiceRequestQuotation",
      fetchServiceRequest: "serviceRequest/fetchServiceRequest",
      getServiceRequestChalans: "serviceRequestChalan/getServiceRequestChalans"
    }),
    ...mapMutations({
      resetQuotation: "serviceRequestQuotation/resetQuotation",
      resetProductData: "serviceRequestQuotation/resetProductData",
      resetDetailedLaborCosts: "serviceRequestQuotation/resetDetailedLaborCosts",
      setQuotation: "serviceRequestQuotation/setQuotation"
    }),
    normalizeChalanList() {
      const raw = this.serviceRequestChalansList;
      if (Array.isArray(raw)) return raw;
      if (raw && Array.isArray(raw.rows)) return raw.rows;
      return [];
    },
    hasPersistedChalans() {
      return this.normalizeChalanList().length > 0;
    },
    hasPersistedExternalGoods() {
      const meta = this.serviceRequest && this.serviceRequest.externalGoodsMeta;
      if (!Array.isArray(meta)) return false;
      return meta.some(
        row =>
          row &&
          ((row.name && String(row.name).trim()) ||
            row.quantity != null ||
            (row.total != null && parseFloat(row.total) > 0))
      );
    },
    notifyQuotationBlockedByWorkData() {
      this.$notify({
        message:
          "Sorry, you cannot add quotation after adding chalan/external goods!",
        type: "danger",
        title: "Error"
      });
    },
    isQuotationStatusAllowed() {
      const code =
        this.serviceRequest.status && this.serviceRequest.status.code;
      return (
        code === "visited" ||
        code === "quotation_pending" ||
        code === "quotation_completed"
      );
    },
    canAddQuotation() {
      if (this.hasPersistedChalans() || this.hasPersistedExternalGoods()) {
        this.notifyQuotationBlockedByWorkData();
        return false;
      }
      if (this.isQuotationStatusAllowed()) {
        return true;
      }
      this.$notify({
        message: "Sorry, you cannot add quotation at this step!",
        type: "danger",
        title: "Error"
      });
      return false;
    },
    addPendingLabor(item) {
      if (!item || !item.laborCostId) return;
      const exists = this.pendingLaborItems.some(
        i => i.laborCostId === item.laborCostId
      );
      if (exists) return;
      this.pendingLaborItems.push({ ...item });
    },
    removePendingLabor(index) {
      this.pendingLaborItems.splice(index, 1);
    },
    createLaborQuotation() {
      if (this.viewOnly) return;
      if (!this.canAddQuotation()) return;
      if (!this.pendingLaborItems.length) {
        this.$notify({
          message: "Add at least one labor item.",
          type: "warning",
          title: "Validation"
        });
        return;
      }
      const total = this.pendingLaborItems.reduce(
        (sum, row) => sum + (parseFloat(row.cost) || 0),
        0
      );
      this.resetQuotation();
      this.resetDetailedLaborCosts();
      this.pendingLaborItems.forEach(item => {
        this.detailedLaborCosts.push({ ...item });
      });
      this.setQuotation({ total, description: "" });
      this.creatingQuotation = true;
      this.saveServiceRequestQuotation({
        type: "detail-labor-cost",
        serviceRequestId: this.$route.params.id
      })
        .then(async () => {
          await this.getServiceRequestQuotations(this.$route.params.id);
          await this.fetchServiceRequest(this.$route.params.id);
          this.pendingLaborItems = [];
          this.laborSearchQuery = "";
          this.resetDetailedLaborCosts();
          this.$notify({
            message: "Quotation created successfully.",
            type: "success",
            title: "Success"
          });
        })
        .catch(() => {
          this.$notify({
            message: "Try Again!",
            type: "danger",
            title: "Failure"
          });
        })
        .finally(() => {
          this.creatingQuotation = false;
        });
    },
    quotationStatusLabel(row) {
      const code = row.status && row.status.code;
      if (code === "accepted") return "Accepted";
      if (code === "declined") return "Rejected";
      if (code === "dispatched") return "Pending";
      if (code === "pending") return "Pending";
      return (row.status && row.status.label) || "Pending";
    },
    quotationStatusClass(row) {
      const code = row.status && row.status.code;
      if (code === "accepted") return "quotation-list-card__status--accepted";
      if (code === "declined") return "quotation-list-card__status--rejected";
      return "quotation-list-card__status--pending";
    },
    formatQuotationDateTime(row) {
      const raw = row.updatedAt || row.createdAt || row.date;
      if (!raw) return "—";
      try {
        return dateFns.format(new Date(raw), "DD-MM-YYYY · H:mm");
      } catch (e) {
        return String(raw);
      }
    },
    quotationLaborCount(row) {
      if (Array.isArray(row.productMeta) && row.productMeta.length) {
        return row.productMeta.length;
      }
      if (row.isDetailed || (row.type || "").toLowerCase().includes("detailed")) {
        return 1;
      }
      return 1;
    },
    canAcceptQuotation(row) {
      if (this.viewOnly || !row.status) return false;
      return (
        (row.status.code === "dispatched" &&
          row.type === "Detailed Product Quotation") ||
        (row.status.code === "pending" &&
          row.type !== "Detailed Product Quotation")
      );
    },
    sumQuotationTotals(quotations) {
      const list = Array.isArray(quotations) ? quotations : [];
      return list.reduce((sum, q) => sum + (parseFloat(q.total) || 0), 0);
    },
    formatQuotationAmount(amount) {
      const value = parseFloat(amount) || 0;
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0
      }).format(value);
    },
    openVendorQuotationModal() {
      this.showVendorQuotationModal = true;
    },
    openRajputQuotationModal() {
      this.showRajputQuotationModal = true;
    },
    resetVendorQuotationDraft() {
      this.laborSearchQuery = "";
      this.pendingLaborItems = [];
    },
    removeLaborCost(index) {
      if (this.serviceRequestQuotations.length > 1) {
        this.serviceRequestQuotations.splice(index, 1);
      } else {
        this.$notify({
          message: "Can not Remove!",
          type: "danger",
          title: "Error"
        });
      }
    },
    addMoreLaborCost() {
      this.serviceRequestQuotations.push({
        description: "",
        total: null,
        isLaborCost: true
      });
    },

    handleCommand(command) {
      if (this.viewOnly) return;
      if (command === "primaryLabor") {
        if (this.hasPersistedChalans() || this.hasPersistedExternalGoods()) {
          this.notifyQuotationBlockedByWorkData();
        } else if (this.isQuotationStatusAllowed()) {
          this.resetQuotation();
          this.showLaborDialog = true;
        } else {
          this.$notify({
            message: "Sorry, you cannot add quotation at this step!",
            type: "danger",
            title: "Error"
          });
        }
      } else if (command === "approxProducts") {
        if (this.hasPersistedChalans() || this.hasPersistedExternalGoods()) {
          this.notifyQuotationBlockedByWorkData();
        } else if (this.isQuotationStatusAllowed()) {
          this.resetQuotation();
          this.showApproxProducts = true;
        } else {
          this.$notify({
            message: "Sorry, you cannot add quotation at this step!",
            type: "danger",
            title: "Error"
          });
        }
      } else if (command === "detailedProducts") {
        if (this.hasPersistedChalans() || this.hasPersistedExternalGoods()) {
          this.notifyQuotationBlockedByWorkData();
        } else if (this.isQuotationStatusAllowed()) {
          this.resetProductData();
          this.resetQuotation();
          this.showDetailedProducts = true;
        } else {
          this.$notify({
            message: "Sorry, you cannot add quotation at this step!",
            type: "danger",
            title: "Error"
          });
        }
      } else if (command === "secondaryLabor") {
        if (this.hasPersistedChalans() || this.hasPersistedExternalGoods()) {
          this.notifyQuotationBlockedByWorkData();
        } else if (this.isQuotationStatusAllowed()) {
          (this.selectedLabor = {}), this.resetDetailedLaborCosts();
          this.resetQuotation();
          this.showDetailedLaborCost = true;
        } else {
          this.$notify({
            message: "Sorry, you cannot add quotation at this step!",
            type: "danger",
            title: "Error"
          });
        }
      }
    },
    handleDetailedProductAdd() {
      this.detailedProductData.push({
        productId: "",
        name: "",
        quantity: null,
        taxRate: null
      });
    },
    handleDetailedProductDelete(index) {
      this.detailedProductData.splice(index, 1);
    },
    async suggestProducts(query, cb) {
      const result = await this.getProducts({ searchKeyword: query });
      cb(result.rows);
    },
    saveQuotation(type) {
      if (this.viewOnly) return;
      this.saveServiceRequestQuotation({
        type,
        serviceRequestId: this.$route.params.id
      })
        .then(async () => {
          await this.getServiceRequestQuotations(this.$route.params.id);
          await this.fetchServiceRequest(this.$route.params.id);
          this.showApproxProducts = false;
          this.showLaborDialog = false;
          this.showDetailedProducts = false;
          this.showDetailedLaborCost = false;
          this.$notify({
            message: "Quotation Added Succesfully....!",
            type: "success",
            title: "Success"
          });
        })
        .catch(() => {
          this.$notify({
            message: "Try Again!",
            type: "danger",
            title: "Failure"
          });
        });
    },
    handleProductSelect(selectedProduct, row) {
      row.productId = selectedProduct.productId;
      (row.name = selectedProduct.name),
        (row.taxRate = selectedProduct.tax.rate);
      row.quantity = 1;
    },
    addDetailedLabor(item) {
      this.detailedLaborCosts.push(item);
    },
    handleDetailedLaborCostDelete(index) {
      this.detailedLaborCosts.splice(index, 1);
    },
    getServiceRequestQuotationDetails(row) {
      this.fetchServiceRequestQuotationDetails(
        row.serviceRequestQuotationId
      ).then(res => {
        row.details = res.data;
        this.serviceRequestQuotationData = res.data;
      });
    },
    updateQuotation(data) {
      if (this.viewOnly) return;
      const newStatus = this.statusList.find(i => i.code === "accepted");
      this.updateServiceRequestQuotation({
        statusId: newStatus.statusId,
        serviceRequestQuotationId: data.serviceRequestQuotationId,
        serviceRequestId: this.$route.params.id
      }).then(res => {
        this.getServiceRequestQuotations(this.$route.params.id);
        this.$notify({
          message: "Quotation Updated Succesfully!",
          type: "success",
          title: "Success"
        });
      });
    }
  }
};
</script>

<style>
.detail-product-remove-item {
  margin-left: 60px;
  margin-top: -30px;
  font-size: 25px;
  cursor: pointer;
}

.detailed-labor-cost-remove-item {
  margin-left: 26px;
  margin-top: 0px;
  font-size: 25px;
  cursor: pointer;
}
.quotation-step__toolbar {
  margin-bottom: 16px;
}
.quotation-step__cards {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}
.quotation-mobile-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.quotation-mobile-card--vendor {
  border-color: #93c5fd;
  border-width: 1px;
  box-shadow: 0 0 0 1px #bfdbfe;
}
.quotation-mobile-card--rajput {
  border-color: #fdba74;
  box-shadow: 0 0 0 1px #fed7aa;
}
.quotation-mobile-card__header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 14px 10px;
}
.quotation-mobile-card__icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}
.quotation-mobile-card__icon--vendor {
  background: #dbeafe;
  color: #2563eb;
}
.quotation-mobile-card__icon--rajput {
  background: #ffedd5;
  color: #ea580c;
}
.quotation-mobile-card__titles {
  flex: 1;
  min-width: 0;
}
.quotation-mobile-card__title {
  margin: 0 0 2px;
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  line-height: 1.3;
  word-break: break-word;
}
.quotation-mobile-card__subtitle {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
}
.quotation-mobile-card__link {
  flex-shrink: 0;
  padding: 4px 0;
  font-size: 13px;
  font-weight: 600;
  color: #2563eb;
  white-space: nowrap;
  border: none;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
}
.quotation-mobile-card__link:hover {
  color: #1d4ed8;
  text-decoration: underline;
}
.quotation-mobile-card__chevron {
  margin-left: 2px;
}
.quotation-mobile-card__stats {
  margin: 0 14px 14px;
  padding: 4px 12px;
  background: #f3f4f6;
  border-radius: 8px;
}
.quotation-stat-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  font-size: 14px;
  color: #374151;
  border-bottom: 1px solid #e5e7eb;
}
.quotation-stat-row:last-child {
  border-bottom: none;
}
.quotation-stat-row span:last-child {
  font-weight: 600;
  color: #111827;
}
.quotation-stat-row--total span:last-child {
  font-weight: 700;
  font-size: 15px;
}
.dispatch-button {
  margin-left: 15px;
  margin-top: 20px;
}
.quotation-panel__title {
  margin: 0 0 6px;
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}
.quotation-panel__hint,
.quotation-panel__empty-hint {
  margin: 0 0 12px;
  font-size: 13px;
  color: #6b7280;
}
.quotation-panel__empty {
  margin: 0;
  padding: 20px 12px;
  text-align: center;
  font-size: 14px;
  color: #9ca3af;
  background: #f9fafb;
  border-radius: 8px;
}
.quotation-create-panel,
.quotation-list-panel {
  margin-top: 20px;
  padding: 16px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
}
.quotation-create-panel--modal,
.quotation-list-panel--modal {
  margin-top: 0;
  margin-bottom: 16px;
  padding: 0;
  border: none;
  background: transparent;
}
.quotation-list-panel--modal:last-child {
  margin-bottom: 0;
}
.quotation-step__toolbar--modal {
  margin-bottom: 16px;
}
.quotation-list-panel--rajput {
  border-color: #fed7aa;
}
.quotation-list-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.quotation-list-panel__badge {
  flex-shrink: 0;
  min-width: 28px;
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  color: #374151;
  background: #f3f4f6;
  border-radius: 999px;
}
.quotation-labor-search {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border: 2px solid #c4b5fd;
  border-radius: 10px;
  background: #fff;
  margin-bottom: 10px;
}
.quotation-labor-search__icon {
  color: #6b7280;
  font-size: 16px;
}
.quotation-labor-search__input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 14px;
}
.quotation-labor-results {
  list-style: none;
  margin: 0 0 12px;
  padding: 0;
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}
.quotation-labor-results__row {
  border-bottom: 1px solid #f3f4f6;
}
.quotation-labor-results__row:last-child {
  border-bottom: none;
}
.quotation-labor-results__pick {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 14px;
  border: none;
  background: #fff;
  text-align: left;
  font-size: 14px;
  cursor: pointer;
}
.quotation-labor-results__pick:hover {
  background: #f9fafb;
}
.quotation-labor-selected {
  list-style: none;
  margin: 0 0 16px;
  padding: 0;
}
.quotation-labor-selected__row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  margin-bottom: 8px;
  background: #f9fafb;
  border-radius: 8px;
  font-size: 14px;
}
.quotation-labor-selected__amount {
  margin-left: auto;
  font-weight: 600;
}
.quotation-labor-selected__remove {
  border: none;
  background: #e5e7eb;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  line-height: 1;
}
.quotation-create-btn {
  width: 100%;
  margin-bottom: 12px;
}
.quotation-step__toolbar--inline {
  margin-bottom: 0;
}
.quotation-list-card {
  padding: 14px;
  margin-bottom: 10px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
}
.quotation-list-card__top {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.quotation-list-card__id {
  font-weight: 700;
  color: #111827;
}
.quotation-list-card__amount {
  margin-left: auto;
  font-weight: 700;
}
.quotation-list-card__status {
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
}
.quotation-list-card__status--accepted {
  background: #16a34a;
}
.quotation-list-card__status--pending {
  background: #6b7280;
}
.quotation-list-card__status--rejected {
  background: #dc2626;
}
.quotation-list-card__meta {
  margin: 8px 0 0;
  font-size: 13px;
  color: #6b7280;
}
.quotation-list-card__accept {
  margin-top: 10px;
}
</style>
